<template>
    <div>
        <div id="hero-banner">
            <div class="bg-parallax banner-image" data-inverted="true" data-speed="0.1" :style="bannerStyle"></div>
            <div class="overlay text-center">
                <h1 id="hero-text">Contact Us</h1>
            </div>
        </div>

        <div class="container pt-6">
            <div class="row mb-7">
                <div class="col-sm-12 text-left">
                    <h2 class="text-default display-3 montserrat-bold text-uppercase">
                        Get in <span class="text-danger inline">touch</span> with us
                    </h2>
                    <p class="text-default mb-5">
                        Have any questions? We'd love to hear from you.
                    </p>
                </div>
                <div class="col-lg-6">
                    <contact-us-form></contact-us-form>
                </div>
                <div class="col-lg-6">
                    <h3 class="text-default display-5 montserrat-bold text-uppercase mb-3">Contact Us</h3>
                    <div class="mb-4">
                        <span class="icon-bullet-icon" style=""><div class="fa fa-phone"></div></span>
                        <div class="icon-bullet-text-wrapper">
                            <!-- <div class="icon-bullet-text">{{ cs.landline }} (Landline)</div> -->
                            <div class="icon-bullet-text">{{ cs.smart }}</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <span class="icon-bullet-icon" style=""><div class="fa fa-envelope"></div></span>
                        <div class="icon-bullet-text-wrapper">
                            <div class="icon-bullet-text">{{ cs.email }}</div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <span class="icon-bullet-icon" style=""><div class="fa fa-envelope"></div></span>
                        <div class="icon-bullet-text-wrapper">
                            <div class="icon-bullet-text">{{ cs.address }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <displayed-address-form :address='@json($address)'></displayed-address-form> -->
        </div>
    </div>
</template>
<script>
import { default as config } from "@src/config";
import { resource } from "@utils/network";
import ContactUsForm from "@views/guests/partials/ContactUsForm";

export default {
    name: "ContactUsPage",

    components: { ContactUsForm },

    data: () => ({
        cs: {
            landline: config.CS_LANDLINE,
            smart: config.CS_MOBILE,
            email: config.CS_EMAIL,
            address: config.CS_ADDRESS,
        }
    }),
    computed: {
        bannerStyle() {
            return `background-image:url('${ resource("images/contact-us.jpg") }')`;
        }
    },

    mounted() {
        this.$store.dispatch("showFooterContacts", false);
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("showFooterContacts");
        next();
    }

}
</script>

<style scoped lang="css">
    #hero-banner {
        position: relative;
        height: 800px;
        overflow: hidden;
    }
    #hero-banner .banner-image {
        height: 100%;
    }
    #hero-text {
        margin-top: 400px;
        font-family: 'Montserrat', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 3.8rem;
        font-weight: 800;
        line-height: 1.5;
    }
    #hero-banner .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0px;
    }
    .company-banner {
        width: 100%;
    }
</style>